<h3 *ngIf="isLoading && !searchResults" [innerHTML]="loadingMessage"></h3>


<div *ngIf="searchResults">
    <div class="bg-primary p-2">
        <div class="row">
            <div class="col-md-8 col-9 dropdown drop-right">
                <button type="button" class="btn btn-primary dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" data-display="static"> Filter: View All </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <ng-container *ngFor="let filter of searchResults.Filters">
                        <a class="dropdown-item" href="#" (click)="onFilterClick($event.target, filter.Text, filter.Value)">{{filter.Text}}</a>
                    </ng-container>
                </div>
            </div>
            <div class="col-md-4 col-3">
                <label class="swapa-top-search input-group m-0 mr-4 d-none d-md-flex align-items-center">
                    <input type="text"
                           id="qnaSearch"
                           [(ngModel)]="searchText"
                           class="form-control"
                           name="qnaSearch"
                           autocomplete="off"
                           #txtSearch
                           (keydown.enter)="performTextSearch($event)"
                           placeholder="Search questions">
                    <div class="input-group-append" style="height:30px">
                        <span class="input-group-text">
                            <div class="swapa-search"></div>
                        </span>
                    </div>
                </label>
                <button class="btn btn-link btn-sm d-md-none swapa-search bg-white rounded-0"
                        id="swapa-qna-search-button" (click)="onSearchClick($event.target)"></button>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div id="swapa-qna-search-dropdown"
                     class="flex-direction-column d-md-none d-none py-2">
                    <label class="swapa-top-search input-group m-0">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <div class="swapa-search"></div>
                            </span>
                        </div>
                        <input type="text"
                               id="qnaSearch"
                               [(ngModel)]="searchText"
                               class="form-control"
                               name="qnaSearch"
                               autocomplete="off"
                               #txtSearch
                               (keydown.enter)="performTextSearch($event)"
                               placeholder="Search questions" />
                    </label>
                    <button class="btn btn-link btn-sm text-white" (click)="closeSearchDropdown($event)">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngFor="let qna of searchResults.Items; let first = first;">
        <h6 [ngClass]="first ? 'text-primary mt-4' : 'text-primary'"> {{qna.SectionName| titlecase}} Question | {{qna.SubmittedDateInString}} | Posted by: {{qna.IsAnonymous ? 'Anonymous' : qna.SubmittedBy}}</h6>
        <p>
            <b>Q:</b> {{qna.Question}}
        </p>
        <p>
            <b>A:</b> {{qna.Answer}}
        </p>
        <hr class="bg-dark" />
    </ng-container>
    <h6 class="text-success text-center mt-4" *ngIf="searchResults && searchResults.TotalMatching>0" [innerHTML]="searchResults.ResultFoundMessage"></h6>
    <h6 class="text-success text-center mt-4" *ngIf="searchResults && searchResults.TotalMatching==0" [innerHTML]="searchResults.NoResultMessage"></h6>
    <!-- pagination -->
    <div *ngIf="searchResults && searchResults.Items?.length>0 && searchResults.TotalMatching > pageSize" class="row justify-content-center">
        <!--<div class="col-12 col-md-5 text-left">
            <span>Showing {{endIndex}} of {{ searchResults.TotalMatching }} results</span>
        </div>-->
        <div class="my-auto">
            <ngb-pagination [collectionSize]="searchResults.TotalMatching" [(page)]="page" [pageSize]="pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
            </ngb-pagination>
        </div>
        <div class="my-auto">
            <p *ngIf="isLoading">Please wait...</p>
        </div>
    </div>

    <div *ngIf="searchResults && searchResults.Items?.length>0" class="swapa-top-tocshortcut text-right text-nonselectable">
        <a class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2" href="#topofbody"> ↑ Back To Top </a>
    </div>
</div>